import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabaseClient';

function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAccess = async () => {
      const { data: { user }, error } = await supabase.auth.getUser();

      if (!user || error) {
        navigate('/');
        return;
      }

      // ✅ No more trial logic
      setLoading(false);
    };

    checkAccess();
  }, [navigate]);

  if (loading) return null; // You can replace this with a spinner if needed

  return children;
}

export default ProtectedRoute;